import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { useLocation, useNavigate } from "react-router";

import Cookies from "js-cookie";
import SearchStaff from "../../../components/Staff/SearchStaff";
import FileUploader from "../../../components/FileUploader";
import TagInput from "../../../components/AddTags";

const EditTask = () => {
  const location = useLocation();
  const { state } = location;

  function handleCloseForm() {
    navigate("/task");
  }

  const navigate = useNavigate();
  const { baseUrl, openToast } = useGlobalContext();
  const [isLoading, setIsLoading] = useState(false);

  const [allTaskStatus, setAllTaskStatus] = useState();
  const [projectDetails, setProjectDetails] = useState([]);

  const [selectedTaskStatusId, setSelectedTaskStatusId] = useState("default"); // State for selected task status ID
  const [members, setMembers] = useState([]);
  const [files, setFiles] = useState([]);

  const fetchAllTaskStatus = async () => {
    try {
      const response = await fetch(baseUrl + "task/status", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      }
      );
      if (response.status === 200) {
        const data = await response.json();
        console.log("taskData:", data);
        setAllTaskStatus(data.taskStatus);
      } else {
        const error = await response.json();
        console.error(error.message || `HTTP Error: ${response.status}`);
        setAllTaskStatus([]);
      }
    } catch (error) {
      console.error("Error fetching task status:", error);
      setAllTaskStatus([]);
    }
  };

  const [divs, setDivs] = useState([{}]); // Start with one empty object

  const addNewDiv = () => {
    setDivs([...divs, {}]); // Add a new empty object to the state array
  };

  async function fetchProjectDetails() {
    try {
      const result = await fetch(baseUrl + `project?page=1&limit=100`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      }
      );
      if (result.status == 200) {
        const res = await result.json();
        console.log(res);
        setProjectDetails(res.data);
      } else {
        console.error("Error fetching projects:", result.status);
        setProjectDetails([]);
      }
    } catch (error) {
      console.error("Error fetching Projects", error);
      setProjectDetails([]);
    }
  }

  async function submitTask(e) {
    e.preventDefault();
    setIsLoading(true);
    if (selectedTaskStatusId === "default") {
      openToast("Please select a task status", "warning");
    }
    if (selectedTaskPriorityId === "default") {
      openToast("Please select a task priority", "warning");
    }
    if (selectedDepartmentId === "default") {
      openToast("Please select a department", "warning");
    }
    if (selectedProjectId === "default") {
      openToast("Please select a project", "warning");
    }
    if (members?.length === 0) {
      openToast("Please assign at least one member", "warning");
    }
    try {

      if (!state?.id) {
        openToast("Task ID is missing", "error");
        return;
      }
      const formData = new FormData();
      formData.append("taskName", taskName);
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);
      formData.append("dueDate", dueDate);
      formData.append("taskDescription", taskDescription);
      if (attachFile) {
        formData.append("attachFile", attachFile);
      }
      formData.append("taskStatusId", selectedTaskStatusId);
      formData.append("departmentId", selectedDepartmentId);
      formData.append("taskPriorityId", selectedTaskPriorityId);
      formData.append("projectId", selectedProjectId);

      files.forEach((file, index) => {
        formData.append(`attachFile[${index}]`, file);
      });

      members.forEach((member, index) => {
        formData.append(`taskAssignee[${index}]`, member);
      });

      tag.forEach((t, index) => {
        formData.append(`taskTag[${index}]`, t);
      });

      const taskId = state.id;
      const result = await fetch(baseUrl + "task/detail/" + taskId, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: formData,
      });

      const data = await result.json();
      console.log(data);
      if (result.ok) {
        openToast(data.message || "Task updated successfully", "success");
        navigate("/task");
      } else {
        openToast(data.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error submitting task:", error);
      openToast("An error occurred while submitting the task", "error");
    } finally {
      setIsLoading(false);
    }
  }



  const [departments, setDepartments] = useState([]);
  const fetchDepartments = async () => {
    try {
      const result = await fetch(baseUrl + "department", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      }
      );
      if (result.status == 200) {
        const res = await result.json();
        setDepartments(res.data);
      } else {
        console.error("Error fetching departments:", result.status);
        setDepartments([]);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      setDepartments([]);
    }
  };

  const handleFileChange = (e) => {
    setAttachFile(e.target.files[0]); // Assuming a single file upload
  };

  const [taskPriority, setTaskPriority] = useState([]);
  const fetchTaskPriority = async () => {
    try {
      const result = await fetch(baseUrl + "task/priority", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      }
      );
      if (result.status == 200) {
        const res = await result.json();
        console.log(res.taskPriority);
        setTaskPriority(res.taskPriority);
      } else {
        const error = await result.json();
        console.log(error.message, "error");
        setTaskPriority([]);
      }
    } catch (error) {
      console.log("error", error);
      setTaskPriority([]);
    }
  };

  const [taskName, setTaskName] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [dueDate, setDueDate] = useState();
  const [taskDescription, setTaskDescription] = useState();
  const [tag, setTag] = useState([]);
  const [attachFile, setAttachFile] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("default");
  const [selectedProjectId, setSelectedProjectId] = useState("default");
  const [selectedTaskPriorityId, setSelectedTaskPriorityId] = useState("default");

  useEffect(() => {
    fetchTaskPriority();
    fetchDepartments();
    fetchProjectDetails();
    fetchAllTaskStatus();
  }, []);

  console.log(state);
  useEffect(() => {
    setTaskName(state?.taskName);
    // setDepartments(state.departments);
    setStartDate(state.startDate);
    setEndDate(state.endDate);
    setDueDate(state.dueDate);
    setTaskDescription(state?.taskDescription);
    setTag(state?.taskTag);
    setAttachFile(state.attachFile);
    setMembers(state?.taskAssignee?.map((m) => m?.id));
    setSelectedTaskStatusId(state?.taskStatusId);
    setSelectedDepartmentId(state?.departmentId);
    setSelectedProjectId(state?.projectId);
    setSelectedTaskPriorityId(state?.taskPriorityId);
  }, [state])
  console.log(members);
  return (
    <div className="flex justify-center items-center form-main mt-[20px] md:mt-[30px] w-[100%] min-h-screen">
      <div className="relative bg-white shadow-cs p-6 rounded-lg w-[90%] md:w-[80%] h-[100%]">
        <h2 className="mb-[16px] font-semibold text-lg">Edit Task</h2>
        <form
          action=""
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              return;
            }
          }}
          onSubmit={submitTask}
        >
          <div className="w-[100%]">
            <div className="w-[100%]">
              <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                Task Name
              </label>
              <br />
              <input
                value={taskName}
                type="text"
                onChange={(e) => setTaskName(e.target.value)}
                className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                required
              />{" "}
              <br />
            </div>
            <div className="flex gap-[8px] billing-form-type">
              <div className="w-[100%]">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Task Status
                </label>{" "}
                <br />
                <select
                  value={selectedTaskStatusId}
                  onChange={(e) => setSelectedTaskStatusId(e.target.value)} // Store only the selected ID as a string
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                >
                  <option value="default">Please Select Task Status</option>
                  {allTaskStatus?.map((status) => (
                    <option key={status?.id} value={status?.id}>
                      {status?.taskStatusName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex gap-[8px] billing-form-type">
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Start Date
                </label>{" "}
                <br />
                <input
                  value={startDate}
                  type="date"
                  onChange={(e) => setStartDate(e.target.value)}
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                />{" "}
                <br />
              </div>
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  End Date
                </label>{" "}
                <br />
                <input
                  value={endDate}
                  type="date"
                  onChange={(e) => setEndDate(e.target.value)}
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                />{" "}
                <br />
              </div>
            </div>
            <div className="flex gap-[8px] billing-form-type">
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Due Date
                </label>{" "}
                <br />
                <input
                  value={dueDate}
                  type="date"
                  onChange={(e) => setDueDate(e.target.value)}
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                />{" "}
                <br />
              </div>
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Select Project
                </label>{" "}
                <br />
                <select
                  value={selectedProjectId}
                  onChange={(e) => setSelectedProjectId(e.target.value)}
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                >
                  <option value="default">- Select Project -</option>{" "}
                  {/* Placeholder option */}
                  {projectDetails?.map((project) => (
                    <option key={project.id} value={project.id}>
                      {project.project_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex gap-[10px] billing-form-type w-[100%]">
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Select Department
                </label>{" "}
                <br />
                <select

                  value={selectedDepartmentId}
                  onChange={(e) => setSelectedDepartmentId(e.target.value)}
                  className="border-1 hover:bg-[#fff] mt-1 mr-[0px] mb-[10px] p-[5px] border rounded-md w-full placeholder:font-font-normal text-[#000] text-[12px] xl:text-[14px] focus:outline-none"
                  required
                >
                  <option value="default">Select Department</option>
                  {departments?.map((department) => (
                    <option key={department.id} value={department.id}>
                      {department.department_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Task Priority
                </label>{" "}
                <br />
                <select
                  value={selectedTaskPriorityId}
                  onChange={(e) => setSelectedTaskPriorityId(e.target.value)} // Set only the selected ID
                  className="border-1 hover:bg-[#fff] mt-1 mr-[0px] mb-[10px] p-[5px] border rounded-md w-full placeholder:font-font-normal text-[#000] text-[12px] xl:text-[14px] focus:outline-none"
                  required
                >
                  <option value="default">Select Task Priority</option>{" "}
                  {/* Placeholder option */}
                  {taskPriority?.map((priority) => (
                    <option key={priority.id} value={priority.id}>
                      {priority.taskPriorityName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="">
              <div className="w-[100%]">
                <SearchStaff
                  members={members}
                  setMembers={setMembers}
                  title="Assign To"
                  names={state?.taskAssignee}
                />
              </div>
              <div className="mt-[10px]">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Task Description
                </label>
                <br />
                <textarea
                  value={taskDescription}
                  type="text"
                  onChange={(e) => setTaskDescription(e.target.value)}
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                />{" "}
                <br />
              </div>
              <div className="mb-4 w-[100%]">
                <TagInput tags={tag} setTags={setTag} />
              </div>
            </div>
            <div>
              <label className="font-medium text-[#000000ba] text-[13px] xl:text-[15px]">
                Attach File
              </label>
              <br />
              <FileUploader setFiles={setFiles} files={files} />
            </div>
            <div className="flex justify-end items-center gap-[10px] pt-3 pr-[10px] pb-[0]">
              <button
                onClick={handleCloseForm}
                className="border-[#27004a] bg-white border rounded-md w-20 h-10 text-[#27004a]"
              >
                Cancel
              </button>

              <button
                className={`allcrm-btn1 ${isLoading == true ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                onClick={submitTask}
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTask;